import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
// import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import { useToast } from '@chakra-ui/react';
import Header from './components/Header/Header';
// import FilterProvider from './context/FilterContext';
import Login from './pages/Login/Login';
import OrcanaLive from './pages/OrcanaLive/OrcanaLive';
// import ClickNarrative from './pages/ClickNarratives/ClickNarratives';
// import AlertsPage from './pages/Alerts/Alerts';
// import Recommendations from './pages/Recommendations/Recommendations';

const SESSION_TIMEOUT = 12 * 60 * 60 * 1000; // 12 hours

// interface JwtPayload {
//   exp: number;
// }

const App: React.FC = () => {
  const [accessToken, setAccessToken] = useState<string | null>(
    Cookies.get('accessToken') || null
  );

  const toast = useToast();

  const handleLogout = (): void => {
    Cookies.remove('accessToken');
    setAccessToken(null);
  };
  
  // useEffect(() => {
  //   if (!accessToken) return;

  //   let timeoutId: ReturnType<typeof setTimeout>;

  //   try {
  //     const decoded = jwtDecode<JwtPayload>(accessToken);
  //     const expiresAt = decoded.exp * 1000;
  //     const currentTime = Date.now();
  //     const timeoutDuration = expiresAt - currentTime;

  //     if (timeoutDuration <= 0) {
  //       handleLogout();
  //       return;
  //     }

  //     timeoutId = setTimeout(() => {
  //       alert('Your session has expired. Please log in again.');
  //       handleLogout();
  //     }, timeoutDuration);
  //   } catch (error) {
  //     handleLogout();
  //   }

  //   return () => clearTimeout(timeoutId);
  // }, [accessToken]);

  useEffect(() => {
    if (!accessToken) return;
    

    const logoutTimer = setTimeout(() => {
      toast({
        title: 'Session Expired',
        description: 'Your session has expired. Please log in again.',
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      handleLogout();
    }, SESSION_TIMEOUT);

    return () => clearTimeout(logoutTimer);
  }, [accessToken, toast]);

  return (
    // <FilterProvider>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        {accessToken ? (
          <>
            <Header onLogout={handleLogout} />
            <div style={{ flex: 1, overflowY: 'auto' }}>
              <Routes>
                <Route path="/" element={<OrcanaLive />} />
                <Route path="/orcana-live" element={<OrcanaLive />} />
                {/* <Route path="/alerts" element={<AlertsPage />} /> */}
                {/* <Route path="/click-narratives/:name" element={<ClickNarrative />} /> */}
                {/* <Route path="/recommendations" element={<Recommendations />} /> */}
              </Routes>
            </div>
          </>
        ) : (
          <Login
            onLogin={(token) => {
              setAccessToken(token);
            }}
          />
        )}
      </div>
    // </FilterProvider>
  );
};

export default App;
